import React, { useEffect } from 'react';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { useNavigate } from 'react-router-dom';
import './Login.css';

/**
 * Rendered the moment Amplify reports a session. It redirects immediately
 * rather than pausing on a confirmation screen — the old version waited a
 * second and printed `user.username`, which on an email-alias pool is the raw
 * Cognito sub (a UUID), so a stranger's-looking id flashed on every sign-in.
 */
const RedirectOnSignIn: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/', { replace: true });
  }, [navigate]);

  return (
    <div className="logged-in-message">
      <h3>Signed in</h3>
      <p>Taking you to the blog…</p>
    </div>
  );
};

const Login: React.FC = () => {
  return (
    <div className="login-container">
      <div className="login-content-wrapper">
          <div className="login-header">
            <h2>Sign In to QED System Design</h2>
            <p>Access exclusive content and save your progress.</p>
          </div>

          <Authenticator>
            {({ user }) => (user ? <RedirectOnSignIn /> : <></>)}
          </Authenticator>
      </div>
    </div>
  );
};

export default Login;
